// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-card__body[data-v-33a2b10c] {\n    padding: 10px !important;\n}\n", ""]);
// Exports
module.exports = exports;
